import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { allRecruitJobs } from '../data/recruitData';

const RecruitListPage: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string>('all');

  const categories = [
    { key: 'all', label: `すべて (${allRecruitJobs.length})` },
    { key: 'バックオフィス・事務', label: `バックオフィス・事務 (${allRecruitJobs.filter(job => job.category === 'バックオフィス・事務').length})` }
  ];

  const filteredJobs = selectedCategory === 'all'
    ? allRecruitJobs
    : allRecruitJobs.filter(job => job.category === selectedCategory);

  return (
    <div className="pt-20 bg-white min-h-screen text-slate-800 antialiased selection:bg-slate-900 selection:text-white">
      {/* パンくずリスト */}
      <div className="border-b border-slate-200 bg-slate-50/70">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-3.5">
          <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-xs text-slate-500">
            <Link to="/" className="hover:text-slate-900 transition-colors">TOP</Link>
            <svg className="w-3.5 h-3.5 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
            <span className="text-slate-900 font-medium">採用情報</span>
          </nav>
        </div>
      </div>

      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-20 sm:pb-28">
        {/* ヘッダーエリア */}
        <div className="space-y-3 pb-8 border-b border-slate-200">
          <div className="text-xs font-bold text-slate-400 tracking-widest uppercase" style={{ fontFamily: "'Inter', sans-serif" }}>
            RECRUIT
          </div>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-950 tracking-tight">
            採用情報
          </h1>
          <p className="text-sm sm:text-base text-slate-600 leading-relaxed">
            株式会社AgLabでは、「AIで日本をアップデートする」をミッションに、急成長する事業を共に推進するメンバーを募集しています。
          </p>
        </div>

        {/* カテゴリフィルタタブ */}
        <div className="py-6 flex flex-wrap items-center gap-2 border-b border-slate-200 mb-8">
          {categories.map(cat => (
            <button
              key={cat.key}
              onClick={() => setSelectedCategory(cat.key)}
              className={`px-4 py-2 text-xs font-semibold rounded-lg transition-colors ${
                selectedCategory === cat.key
                  ? 'bg-slate-950 text-white border border-slate-950'
                  : 'bg-white text-slate-600 border border-slate-200 hover:border-slate-300 hover:text-slate-900'
              }`}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {/* 求人カードリスト */}
        <div className="space-y-5">
          {filteredJobs.map(job => (
            <Link
              key={job.id}
              to={`/recruit/${job.id}`}
              className="group block p-6 sm:p-7 rounded-xl border border-slate-200 bg-white hover:border-slate-400 hover:shadow-md transition-all"
            >
              <div className="space-y-3">
                <div className="flex flex-wrap items-center justify-between gap-2 text-xs">
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-semibold text-slate-700 bg-slate-100 px-2.5 py-1 rounded">
                      {job.category}
                    </span>
                    <span className="text-xs font-semibold text-blue-700 bg-blue-50 border border-blue-200/60 px-2.5 py-1 rounded">
                      {job.workStyle}
                    </span>
                  </div>
                  <span className="text-slate-400 font-mono text-[11px]">{job.jobCode}</span>
                </div>

                <h2 className="text-lg sm:text-xl font-bold text-slate-950 leading-snug group-hover:text-blue-600 transition-colors">
                  {job.title}
                </h2>

                <p className="text-xs sm:text-sm text-slate-600 leading-relaxed">
                  {job.summary}
                </p>
              </div>

              <div className="pt-4 border-t border-slate-100 flex flex-col sm:flex-row sm:items-center justify-between gap-4 text-xs mt-4">
                <div className="flex flex-wrap items-center gap-4 text-slate-600 font-medium">
                  <span className="text-slate-900 font-bold" style={{ fontFamily: "'Inter', sans-serif" }}>
                    {job.salary}
                  </span>
                  <span className="text-slate-300">|</span>
                  <span>{job.workStyle}（在宅勤務）</span>
                  <span className="text-slate-300">|</span>
                  <span>{job.workingHours}（残業月0〜5h）</span>
                </div>

                <div className="inline-flex items-center gap-1.5 font-bold text-slate-950 group-hover:text-blue-600 transition-colors whitespace-nowrap self-end sm:self-auto">
                  <span>募集要項を見る</span>
                  <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
};

export default RecruitListPage;